import { Illustration } from "../Illustration.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/illustration/variants/PrescriptionIllustration.tsx
const PrescriptionIllustration = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(Illustration, {
		...props,
		svgFile: "prescription.svg",
		alt: t("illustration.imageAlt.prescriptionPaper")
	});
};

//#endregion
export { PrescriptionIllustration };